<template>
  <div style="padding: 0 20px 20px">
    <el-form :model="form" :rules="rules" ref="packageForm" label-width="120px">
      <el-form-item label="服务包名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入服务包名称"></el-input>
      </el-form-item>
      <el-form-item label="所属组织" prop="oid">
        <el-cascader v-fixZoom v-model="form.oid" :options="orgTree" :props="orgCascaderProps"
                     filterable clearable placeholder="请选择所属组织" style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="服务内容" prop="st_id">
        <el-cascader v-fixZoom v-model="form.st_id" :options="serviceTypeTree" :props="stCascaderProps"
                     filterable clearable placeholder="请选择服务内容" style="width:100%">
          <template #default="{data}">
            <span v-if="data.is_service !== 1" style="font-style:italic;color:#999999">{{ data.typename }}</span>
            <strong v-else style="color:#1a1a1a">{{ data.typename }}</strong>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="服务商">
        <el-select v-fixZoom v-model="form.supplier_org_id" placeholder="请选择服务商" style="width:100%" filterable>
          <el-option label="待分配" :value="0"></el-option>
          <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联服务模式">
        <el-radio-group v-model="form.service_mode">
          <el-radio :label="1">按服务类型</el-radio>
          <el-radio :label="2">按项目</el-radio>
          <el-radio :label="3">按项目服务商</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="服务性质">
        <el-input v-model="form.service_nature" placeholder="如：居家服务、机构服务等"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="总上门次数" prop="total_count">
            <el-input-number v-model="form.total_count" :min="1" :max="999" style="width:100%"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="间隔月数" prop="interval_months">
            <el-input-number v-model="form.interval_months" :min="1" :max="120" style="width:100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务开始时刻">
            <el-time-picker v-model="form.begin_hour" value-format="HH:mm:ss" format="HH:mm:ss"
                            placeholder="开始时刻" style="width:100%"></el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务结束时刻">
            <el-time-picker v-model="form.end_hour" value-format="HH:mm:ss" format="HH:mm:ss"
                            placeholder="结束时刻" style="width:100%"></el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="状态">
        <el-radio-group v-model="form.is_active">
          <el-radio :label="1">生效</el-radio>
          <el-radio :label="2">暂停</el-radio>
          <el-radio :label="3">结束</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="服务流程">
        <el-input v-model="form.service_process" type="textarea" :rows="2" placeholder="请输入服务流程"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="有效开始日期">
            <el-date-picker v-fixZoom v-model="form.valid_start_date" type="date" value-format="yyyy-MM-dd"
                            placeholder="服务包有效开始日期" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效结束日期">
            <el-date-picker v-fixZoom v-model="form.valid_end_date" type="date" value-format="yyyy-MM-dd"
                            placeholder="服务包有效结束日期" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="isAdd">
        <el-divider content-position="left">关联老人（可选）</el-divider>
        <el-form-item label="服务开始日期">
          <el-date-picker v-fixZoom v-model="form.start_date" type="date"
                          placeholder="第一次生成服务单日期（留空=今天）"
                          value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="搜索老人">
          <div style="display:flex;gap:8px">
            <el-input v-model="personSearch" placeholder="输入老人姓名搜索" style="flex:1"
                      @keyup.enter.native="searchPersons"></el-input>
            <el-button type="primary" @click="searchPersons" :loading="searchLoading">搜索</el-button>
          </div>
        </el-form-item>
        <el-form-item label=" " v-if="personResults.length > 0">
          <el-table :data="personResults" size="mini" border max-height="160">
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phone" label="电话" align="center"></el-table-column>
            <el-table-column align="center" width="70" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="addPersonToList(scope.row)"
                           :disabled="isPersonAdded(scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="已选老人" v-if="selectedPersons.length > 0">
          <el-tag v-for="(p, idx) in selectedPersons" :key="p.id" closable
                  @close="removeFromSelected(idx)" style="margin:2px 4px 2px 0">{{ p.name }}</el-tag>
        </el-form-item>
      </template>
    </el-form>
    <div>
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeDialog"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitForm"><span>确定</span></div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import { queryorg } from '../../../api/organizer'
import {
  querysuppliertype,
  querysupplierorgnotype,
  createpersonservicepackage,
  updatepersonservicepackage
} from '../../../api/serviceMark'
import { searcholdperson } from '../../../api/serviceObject'

export default {
  name: 'addEditServicePackage',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: true,
      orgTree: [],
      serviceTypeTree: [],
      allServiceTypes: [],
      supplierList: [],
      orgCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child',
        emitPath: false
      },
      stCascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'typename',
        children: 'child',
        emitPath: false,
        disabled: 'isService'
      },
      personSearch: '',
      personResults: [],
      searchLoading: false,
      selectedPersons: [],
      form: {
        id: 0,
        name: '',
        oid: '',
        st_id: '',
        supplier_org_id: 0,
        total_count: 6,
        interval_months: 2,
        begin_hour: '',
        end_hour: '',
        pss_type: 1,
        remark: '',
        service_process: '',
        service_requirements: '',
        picture_requirements: '',
        service_requirements_tag: 0,
        picture_requirements_tag: 0,
        is_active: 1,
        service_mode: 1,
        service_nature: '',
        valid_start_date: '',
        valid_end_date: '',
        pids: [],
        start_date: ''
      },
      rules: {
        name: [{ required: true, message: '请输入服务包名称', trigger: 'blur' }],
        oid: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        st_id: [{ required: true, message: '请选择服务内容', trigger: 'change' }],
        total_count: [{ required: true, message: '请输入总上门次数', trigger: 'blur' }],
        interval_months: [{ required: true, message: '请输入间隔月数', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.isAdd = this.addEdit.isAdd
    if (!this.isAdd && this.addEdit.row) {
      let r = this.addEdit.row
      this.form.id = r.id
      this.form.name = r.name
      this.form.oid = r.oid
      this.form.st_id = r.st_id
      this.form.supplier_org_id = r.supplier_org_id
      this.form.total_count = r.total_count
      this.form.interval_months = r.interval_months
      this.form.begin_hour = r.begin_hour
      this.form.end_hour = r.end_hour
      this.form.pss_type = r.pss_type || 1
      this.form.remark = r.remark || ''
      this.form.service_process = r.service_process || ''
      this.form.service_requirements = r.service_requirements || ''
      this.form.picture_requirements = r.picture_requirements || ''
      this.form.service_requirements_tag = r.service_requirements_tag || 0
      this.form.picture_requirements_tag = r.picture_requirements_tag || 0
      this.form.is_active = r.is_active
      this.form.service_mode = r.service_mode || 1
      this.form.service_nature = r.service_nature || ''
      this.form.valid_start_date = r.valid_start_date || ''
      this.form.valid_end_date = r.valid_end_date || ''
    }
    this.loadOrgTree()
    this.loadServiceTypeTree()
    this.loadSuppliers()
  },
  computed: {
    selectedServiceType () {
      if (!this.form.st_id) return null
      return this.allServiceTypes.find(t => t.id === this.form.st_id) || null
    },
    parsedServiceReqs () {
      if (!this.selectedServiceType || this.selectedServiceType.service_requirements_tag !== 1) return [[], []]
      try {
        const parsed = JSON.parse(this.selectedServiceType.service_requirements)
        return Array.isArray(parsed) ? [parsed[0] || [], parsed[1] || []] : [[], []]
      } catch (e) { return [[], []] }
    },
    parsedPictureReqs () {
      if (!this.selectedServiceType || this.selectedServiceType.picture_requirements_tag !== 1) return []
      try {
        const parsed = JSON.parse(this.selectedServiceType.picture_requirements)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) { return [] }
    }
  },
  methods: {
    // ---- 数据加载 ----
    loadOrgTree () {
      queryorg().then(res => {
        const arr = (res.data.org || []).filter(o => o.org_type === 0)
        let minLevel = arr.reduce((min, o) => Math.min(min, o.level), 100)
        let roots = arr.filter(o => o.level === minLevel)
        roots.forEach(root => {
          const children = this.arrayToOrgNode(arr, root.id)
          if (children.length) root.child = children
        })
        this.orgTree = roots
      }).catch(() => {})
    },
    arrayToOrgNode (arr, pid) {
      return arr.filter(o => o.orgpid === pid).map(o => {
        const children = this.arrayToOrgNode(arr, o.id)
        if (children.length) o.child = children
        return o
      })
    },
    loadServiceTypeTree () {
      querysuppliertype({ page: 1, size: 99999 }, { orgid: [] }).then(res => {
        const arr = (res.data.types || []).map(o => {
          o.isService = o.is_service === 0
          return o
        })
        this.allServiceTypes = arr
        let minLevel = arr.reduce((min, o) => Math.min(min, o.level), 100)
        let roots = arr.filter(o => o.level === minLevel)
        roots.forEach(root => {
          const children = this.arrayToTypeNode(arr, root.id)
          if (children.length) root.child = children
        })
        this.serviceTypeTree = roots
      }).catch(() => {})
    },
    arrayToTypeNode (arr, pid) {
      return arr.filter(o => o.upid === pid).map(o => {
        const children = this.arrayToTypeNode(arr, o.id)
        if (children.length) o.child = children
        return o
      })
    },
    loadSuppliers () {
      querysupplierorgnotype({ page: 1, size: 9999 }).then(res => {
        this.supplierList = res.data.org || []
      }).catch(() => {})
    },
    // ---- 弹窗 ----
    closeDialog () {
      this.$emit('change', false)
    },
    // ---- 老人搜索 ----
    searchPersons () {
      if (!this.personSearch.trim()) {
        this.$message({ message: '请输入姓名进行搜索', type: 'warning' })
        return
      }
      this.searchLoading = true
      searcholdperson({ lessname: this.personSearch, page: 1, size: 20 }).then(res => {
        this.personResults = res.data.persons || []
        if (this.personResults.length === 0) {
          this.$message({ message: '未找到匹配老人', type: 'info' })
        }
        this.searchLoading = false
      }).catch(() => { this.searchLoading = false })
    },
    addPersonToList (person) {
      if (!this.isPersonAdded(person)) {
        this.form.pids.push(person.id)
        this.selectedPersons.push(person)
      }
    },
    removeFromSelected (idx) {
      this.form.pids.splice(idx, 1)
      this.selectedPersons.splice(idx, 1)
    },
    isPersonAdded (person) {
      return this.form.pids.indexOf(person.id) > -1
    },
    // ---- 提交 ----
    submitForm () {
      this.$refs.packageForm.validate(valid => {
        if (!valid) return
        if (this.isAdd) {
          let data = Object.assign({}, this.form)
          if (!data.start_date) delete data.start_date
          createpersonservicepackage(data).then(() => {
            this.$notify({ title: '成功', message: '新建服务包成功', type: 'success', duration: 2000 })
            this.$emit('refresh')
            this.$emit('change', false)
          }).catch(() => {})
        } else {
          let data = {
            id: this.form.id,
            name: this.form.name,
            oid: this.form.oid,
            st_id: this.form.st_id,
            supplier_org_id: this.form.supplier_org_id,
            total_count: this.form.total_count,
            interval_months: this.form.interval_months,
            begin_hour: this.form.begin_hour,
            end_hour: this.form.end_hour,
            pss_type: this.form.pss_type,
            remark: this.form.remark,
            service_process: this.form.service_process,
            service_requirements: this.form.service_requirements,
            picture_requirements: this.form.picture_requirements,
            service_requirements_tag: this.form.service_requirements_tag,
            picture_requirements_tag: this.form.picture_requirements_tag,
            is_active: this.form.is_active,
            service_mode: this.form.service_mode,
            service_nature: this.form.service_nature,
            valid_start_date: this.form.valid_start_date,
            valid_end_date: this.form.valid_end_date
          }
          updatepersonservicepackage(data).then(() => {
            this.$notify({ title: '成功', message: '修改服务包成功', type: 'success', duration: 2000 })
            this.$emit('refresh')
            this.$emit('change', false)
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/addEditServicePackage.vue